import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  commentForDummyUserApi,
  createPost,
  createPostDummyUserApi,
  engagementPostListApi,
  proListApi,
} from "../Api/api";
import { toast } from "react-toastify";
import {
  createPostFail,
  createPostLoad,
  createPostSuccess,
  dummyCreatePostFail,
  dummyCreatePostLoad,
  dummyCreatePostSuccess,
  dummyUserpostLikeFail,
  dummyUserPostLikeLoad,
  dummyUserpostLikeSuccess,
  engagementFarmingListFail,
  engagementFarmingListLoad,
  engagementFarmingListSuccess,
} from "../slices/engagementFarming.slice";

function* postCreateSaga(action) {
  try {
    const response = yield call(createPost, action.payload);
    if (response?.status == 0) {
      toast.success(response?.result?.message);
      // navigate("/post")
      yield put(createPostSuccess(response?.result?.data));
    } else {
      toast.error(response?.result?.message);
      yield put(createPostFail());
    }
  } catch (error) {
    toast.error(error);
    yield put(createPostFail());
  }
}
function* engagementFarmingListSaga(action) {
  try {
    const response = yield call(engagementPostListApi, action.payload);
    if (response.status === 0) {
      yield put(engagementFarmingListSuccess(response.result.data));
    } else {
      toast.error("Failed to load pros");
      yield put(engagementFarmingListFail());
    }
  } catch (e) {
    // toast.error("Server error");
    yield put(engagementFarmingListFail());
  }
}

function* dummyUserLikeSaga(action) {
  try {
    console.log(action.payload, "232");
    const response = yield call(commentForDummyUserApi, action.payload);
    if (response?.status == 0) {
      yield put(dummyUserpostLikeSuccess(response?.result?.data));
      // yield put(commentUserSuccess(action?.payload));
    }
  } catch (error) {
    // toast.error(error);
    yield put(dummyUserpostLikeFail());
  }
}

function* dummyCreatePostSaga(action) {
  try {
    const response = yield call(createPostDummyUserApi, action.payload);
    if (response?.status == 0) {
      toast.success(response?.result?.message);
      yield put(dummyCreatePostSuccess(response?.result?.data));
    } else {
      toast.error(response?.result?.message);
      yield put(dummyCreatePostFail());
    }
  } catch (error) {
    toast.error(error);
    yield put(dummyCreatePostFail());
  }
}

function* EngagementFarmingSaga() {
  yield takeLatest(createPostLoad.type, postCreateSaga);
  yield takeLatest(engagementFarmingListLoad.type, engagementFarmingListSaga);
  yield takeLatest(dummyUserPostLikeLoad.type, dummyUserLikeSaga);
  yield takeLatest(dummyCreatePostLoad.type, dummyCreatePostSaga);
}

export default EngagementFarmingSaga;
